import { useTranslation } from "react-i18next"

import { Button, ButtonVariant } from "shared/ui/buttons/Button"
import { IconName } from "shared/ui/icon/__generated__/IconName"

interface ClarificationRequestFormDismissButtonProps {
  onDismiss: () => void
  isLoading?: boolean
}

export function ClarificationRequestFormDismissButton({
  onDismiss,
  isLoading
}: ClarificationRequestFormDismissButtonProps) {
  const { t } = useTranslation()

  return (
    <Button
      variant={ButtonVariant.SECONDARY}
      icon={IconName.CHECK}
      label={t("ClarificationRequest.Form.DismissButton.Label")}
      isLoading={isLoading}
      onClick={onDismiss}
    />
  )
}
